import React from 'react';
import { Stack } from '@grnhse/seedling/lib/birch/layouts/stack_v2';
import { TertiaryButton } from '@grnhse/seedling/lib/birch/components/buttons';
import {
  AdvancedFilters,
  ApplicationFiltersGroup,
  CandidateFiltersGroup,
  Fraud,
  Keywords,
  SavedForLater,
} from 'talent_matching/components/filters';
import { useTalentMatchingTabContext } from 'talent_matching/contexts/talent_matching_tab_context';
import { withLocalePrefix } from 'shared/utils/translation';
import AppliedFiltersRow from 'talent_matching/components/applied_filters/applied_filters_row';
import styled from 'styled-components';

const t = withLocalePrefix('talent_matching.filter_row.buttons');

const NoWrap = styled(Stack)`
  white-space: nowrap;
`;

type Props = {
  onClearAll: () => void;
  children: React.ReactNode;
};

const FilterRow = ({ onClearAll, children }: Props) => {
  const { canUseFraudFilter } = useTalentMatchingTabContext();

  return (
    <Stack spacing={0}>
      <Stack direction="row" justifyContent="space-between">
        <NoWrap spacing={1} direction="row" alignItems="center" flexWrap="wrap">
          <SavedForLater />
          {canUseFraudFilter && <Fraud />}
          <ApplicationFiltersGroup />
          <CandidateFiltersGroup />
          <Keywords />
          <AdvancedFilters />
          <TertiaryButton size="md" onClick={onClearAll}>
            {t('clear_all')}
          </TertiaryButton>
        </NoWrap>
        {children}
      </Stack>
      <AppliedFiltersRow />
    </Stack>
  );
};

export default FilterRow;
